export default "__VITE_ASSET__DVF5sgLj__"